module.exports = __webpack_public_path__ + "img/badge_assirete.c5858bc0.jpg";